import { useState, useEffect } from 'react';
import { fetchWithAuth } from 'utils/fetchWithAuth'

function usePersonSearch({
  API_URL,
  endpoint,
  open,
  lot,
  initFields,
  fakeResults = null
}) {
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [fields, setFields] = useState(initFields());
  const [isExisting, setIsExisting] = useState(false);

  // Reset à chaque ouverture
  useEffect(() => {
    if (open && lot) {
      setSearch('');
      setResults([]);
      setFields(initFields());
      setIsExisting(false);
    }
  }, [open, lot, initFields]);

  // Recherche API
  useEffect(() => {
    if (!endpoint) {
      setResults(fakeResults ?? []);
      return;
    }
    if (search.length < 2) {
      setResults([]);
      return;
    }
    setLoading(true);
    fetchWithAuth(`${API_URL}${endpoint}?q=${encodeURIComponent(search)}`)
      .then(res => res.json())
      .then(data => setResults(Array.isArray(data) ? data : []))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, [API_URL, endpoint, search, fakeResults]);

  return {
    search, setSearch,
    loading, 
    results, setResults,
    fields, setFields,
    isExisting, setIsExisting
  };
}

export default usePersonSearch;